import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Importação das páginas seguindo a nova hierarquia de subpastas
import Home from './pages/Home'; 
import News from './pages/News';
import NewsDetail from './pages/NewsDetail';
import Championships from './pages/Championships';
import ChampionshipDetail from './pages/ChampionshipDetail';
import Teams from './pages/Teams';
import TeamDetail from './pages/TeamDetail';
import Races from './pages/Races';
import RaceDetail from './pages/RaceDetail';
import Leagues from './pages/Leagues';
import Pilots from './pages/Pilots';
import LeagueDetail from './pages/LeagueDetail';
import AddLeague from './pages/AddLeague';
import AddLeagueManual from './pages/AddLeagueManual';
import OrganizerPanel from './pages/OrganizerPanel';
import OrganizerChampionshipDetail from './pages/OrganizerChampionshipDetail';
import OrganizerRaceForm from './pages/OrganizerRaceForm';
import OrganizerPointsConfig from './pages/OrganizerPointsConfig';
import CreateChampionship from './pages/CreateChampionship';
import LiveRace from './pages/LiveRace';
import SeriesPage from './pages/Series';
import ClaimLeague from './pages/ClaimLeague';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import EmBreve from './pages/EmBreve';
import Donations from './pages/Donations';
import ProtestForm from './pages/ProtestForm';
import Marketplace from './pages/Marketplace';
import MarketplaceNew from './pages/MarketplaceNew';
import MarketplaceDetail from './pages/MarketplaceDetail';
import MarketplacePayment from './pages/MarketplacePayment';
import MarketplacePaymentSuccess from './pages/MarketplacePaymentSuccess';
import WidgetInfo from './pages/WidgetInfo';
import WidgetStandings from './pages/WidgetStandings';
import WidgetSchedule from './pages/WidgetSchedule';
import WidgetResults from './pages/WidgetResults';
import Tools from './pages/Tools';
import FuelCalculator from './pages/tools/FuelCalculator';
import FovCalculator from './pages/tools/FovCalculator';
import EndurancePlanner from './pages/tools/EndurancePlanner';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/news" element={<News />} />
        <Route path="/news/:id" element={<NewsDetail />} /> {/* Adicionada rota para detalhes da notícia */}
        <Route path="/championships" element={<Championships />} />
        <Route path="/teams" element={<EmBreve />} />
        <Route path="/races" element={<Races />} />
        <Route path="/leagues" element={<Leagues />} />
        <Route path="/pilots/:id" element={<Pilots />} /> {/* Adiciona a rota para detalhes de piloto */}
        {/* Rota dinâmica para detalhes da corrida usando o ID da subsession */}
        <Route path="/championships/:id" element={<ChampionshipDetail />} />
        <Route path="/teams/:id" element={<TeamDetail />} />
        <Route path="/races/:id" element={<RaceDetail />} />
        <Route path="/races/:id/live" element={<LiveRace />} />
        <Route path="/sessions/:id/live" element={<LiveRace />} />
        <Route path="/leagues/:id" element={<LeagueDetail />} />
        <Route path="/leagues/:id/claim" element={<ClaimLeague />} />
        <Route path="/leagues/:id/organizer" element={<OrganizerPanel />} />
        <Route path="/leagues/:id/organizer/create-championship" element={<CreateChampionship />} />
        <Route path="/leagues/:id/organizer/championships/:champId" element={<OrganizerChampionshipDetail />} />
        <Route path="/leagues/:id/organizer/championships/:champId/points" element={<OrganizerPointsConfig />} />
        <Route path="/leagues/:id/organizer/championships/:champId/races/:sessionId" element={<OrganizerRaceForm />} />
        <Route path="/leagues/:leagueId/series/:seriesId" element={<SeriesPage />} />
        <Route path="/pilots" element={<EmBreve />} />
        <Route path="/rankings" element={<EmBreve />} />
        <Route path="/statistics" element={<EmBreve />} />
        <Route path="/fantasy" element={<EmBreve />} />
        <Route path="/add-league" element={<AddLeague />} />
        <Route path="/add-league/manual" element={<AddLeagueManual />} />
        <Route path="/termos" element={<Terms />} />
        <Route path="/privacidade" element={<Privacy />} />
        <Route path="/donations" element={<Donations />} />
        <Route path="/races/:id/protest" element={<ProtestForm />} />
        <Route path="/marketplace" element={<Marketplace />} />
        <Route path="/marketplace/payment" element={<MarketplacePayment />} />
        <Route path="/marketplace/payment-success" element={<MarketplacePaymentSuccess />} />
        <Route path="/marketplace/new" element={<MarketplaceNew />} />
        <Route path="/marketplace/:id" element={<MarketplaceDetail />} />
        <Route path="/tools" element={<Tools />} />
        <Route path="/tools/fuel" element={<FuelCalculator />} />
        <Route path="/tools/fov" element={<FovCalculator />} />
        <Route path="/tools/endurance" element={<EndurancePlanner />} />
        <Route path="/widget-info" element={<WidgetInfo />} />
        <Route path="/widget/leagues/:leagueId/championships/:champId/standings" element={<WidgetStandings />} />
        <Route path="/widget/leagues/:leagueId/championships/:champId/schedule" element={<WidgetSchedule />} />
        <Route path="/widget/leagues/:leagueId/championships/:champId/results" element={<WidgetResults />} />
      </Routes>
    </Router>
  );
}

export default App;
